import { createContext } from 'react';
import { IAuthDetails } from 'utils/authUtils';

export const AuthContext = createContext<IAuthDetails>({});
